<template>
<transition name="modal">
<div id='audio'>
	<div class="player-container">
		
		<!-- Wave bg-->
		<div class="wave-container">
			<div class="header-container">
				<span class="header-title"></span>
			</div>
			<div class="wave -one"></div>
			<div class="wave -two"></div>
			<div class="wave -three"></div>
		</div>
		<!-- <div class="audio-controls">
			<audio controls><source type="audio/mpeg"></audio>
			<button class="close-btn" onclick='closeAudio();'>X</button>
		</div> -->
      <ul id="main_list">
            
      </ul>
      <div class="audio-inner-wrapper">
         <div id="jquery_jplayer_1" class="jp-jplayer"></div>
         <div id="jp_container_1" class="jp-audio" role="application" aria-label="media player">
            <div class="jp-padding">
               <div class="jp-type-single">
                  <button id="play">
                     <img src="./assets/img/bttn-play.svg">
                  </button>
                  <button id="pause">
                     <img src="./assets/img/bttn-pause.svg">
                  </button>
                  <div class="progress">
                     <div class="seek-wrapper">
                        <div id="seek_bar">
                           <div id="play_bar">
                              <div class="jp-ball"></div>
                           </div>
                        </div>
                     </div>
                  </div>
               <span id="duration"></span>
                  <img id="volume_icon" src="./assets/img/icon-volume.svg">
                  <div id="volume_bar">
                     <div id="volume_value"></div>
                  </div>

                  <img id="close_btn_audio" class="close-btn-red" @click.stop="$emit('close')" src="./assets/img/bttn-close.svg">
               </div>
            </div>
         </div>
      </div>

       <div class="carousel-btns" v-if="asset.val.length > 1">
         <div class="prev-wrapper-aud carousel-btn-wrapper">
            <img class="prev" @click="handleSwitch" src="./assets/img/bttn-left.svg">
         </div>

         <div class="next-wrapper-aud carousel-btn-wrapper">
            <img class="next" @click="handleSwitch" src="./assets/img/bttn-right.svg">
         </div>
      </div>

	</div>
</div>
</transition>
</template>

<script>
import Overlay from './Overlay';

export default {
   extends: Overlay,

   mounted() {
      let audio = this.GALLERY_HOST + '/' + this.asset.val[0];
      let title = this.asset.title[0];
      let self = this;
      $(function() {
         "use strict";
          //create slider
         var mainSlider = $('#main_list').slick({
            cssEase: 'linear',
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            vertical: false,
            adaptiveWidth: true,
            centerMode: true,
            prevArrow: $('.prev'),
            nextArrow: $('.next'),
         });

         //load thumnails into the main list
         let i = 0;
         self.asset.val.forEach((file) => {
            $("#main_list")
               .append('<div class="audio-wrapper" data-val="'+self.asset.val[i]+'"></div>');
            i++;
         });

         mainSlider.slick('refresh');
         mainSlider.show();


         $('#main_list').on('afterChange', function(event, slick, currentSlide, nextSlide){
            var aud = $('#main_list .slick-current .audio-wrapper').attr('data-val');
            console.log(vid);
            self.switchAudio(aud);
            $('.header-title').text(self.asset.title[currentSlide]);
            // $('#main_list .slick-slide[data-slick-index="' + currentSlide + '"] .thumb-wrapper img').css('display', 'none');
         });


         $("#jquery_jplayer_1").jPlayer({
            ready: function() {
               $(this).jPlayer( "setMedia", {
                  m4a: audio
               });

               $(this).jPlayer('play');
            },
            timeupdate: function(event) {
               $("#jp_container_1 .jp-ball").css("left",event.jPlayer.status.currentPercentAbsolute + "%");
            },
            cssSelectorAncestor: "#jp_container_1",
            cssSelector: {
               title: "#title",
               play: "#play",
               pause: "#pause",
               currentTime: "#currentTime",
               duration: "#duration",
               seekBar: "#seek_bar",
               playBar: "#play_bar",
               volumeBar: "#volume_bar",
               volumeBarValue: "#volume_value"
            },
            swfPath: "/js",
            supplied: "m4a, oga",
            useStateClassSkin: true,
            autoBlur: false,
            smoothPlayBar: true,
            keyEnabled: true,
            remainingDuration: true,
            toggleDuration: true,
            ended: function() {
               closeAudio();
            }
         });
      });
   },

   methods: {
      handleSwitch() {
         $('.jp-jplayer').css('visibility', 'hidden');
      },

      switchAudio(video) {
         let self = this;
         $(function() {
            "use strict";

            $("#jquery_jplayer_1").jPlayer("setMedia", {
               m4v: self.GALLERY_HOST + '/' + video
            });

            $('.jp-jplayer').css('visibility', 'visible');

            $("#jquery_jplayer_1").jPlayer('play');
         });
      }
   }
}
</script>
